import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ArrowSvg from '../../../../public/static/arrow.svg';
import { IArrowProps } from './ISimpleGallery';

const DOTSIZE = 10;

export const StyledComponentWrapper = styled.div`
    .react-swipeable-view-container > div {
        display: flex;
        justify-content: center;
        overflow: hidden;
    }
`;

export const StyledDotContainer = styled.div`
    z-index: 2;
    position: absolute;
    bottom: 5px;
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const StyledDotButton = styled.button`
    height: ${Math.floor(DOTSIZE + 5)}px;
    width: ${Math.floor(DOTSIZE + 5)}px;
    cursor: pointer;
    border: 0;
    padding: 0;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledDot = styled.div<{ active: boolean }>`
    height: ${DOTSIZE}px;
    width: ${DOTSIZE}px;
    background: ${(props) =>
        props.active ? props.theme.shades.white : props.theme.shades['white-70']};
    border-radius: ${Math.floor(DOTSIZE / 2)}px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
`;

export const StyledArrowContainer = styled.div`
    z-index: 2;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: auto;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
`;

export const StyledArrow = styled.button`
    width: 25px;
    padding: 0;
    background: none;
    border: none;
    margin-left: 5px;
    margin-right: 5px;
    height: 65%;
    outline: 0 none;
    pointer-events: auto;
`;

export const StyledArrowComponent = styled(
    ({
        showShadow,
        ...rest
    }: IArrowProps & { fill: string; showShadow: boolean; orientation: string }) => (
        <ArrowSvg {...rest} />
    ),
)`
    fill: ${(props: { fill: string }) => props.fill};
    opacity: ${(props: IArrowProps) => (activeArrow(props) ? '0.2' : '1')};
    transform: ${(props) => (props.orientation === 'left' ? 'rotate(180deg)' : '')};
    ${(props) =>
        props.showShadow
            ? css`
                  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5));
              `
            : ''};
`;

const activeArrow = (props: IArrowProps) =>
    props.showfadedarrow === 'true' && (props.startitem === 'true' || props.lastitem === 'true');
